import { Button, ButtonGroup, Stack, Typography } from "@mui/material";
import type { ReactElement } from "react";
import type { RatingScore } from "../../domain/types";
import { ratingLabels } from "../../domain/types";

const scores: readonly RatingScore[] = [-2, -1, 0, 1, 2];

export const RatingButtons = ({
  value,
  onChange,
  disabled = false,
}: {
  readonly value: RatingScore | undefined;
  readonly onChange: (score: RatingScore | undefined) => void;
  readonly disabled?: boolean;
}): ReactElement => (
  <Stack spacing={1}>
    <Typography variant="caption" color="text.secondary">
      Your rating
    </Typography>
    <ButtonGroup fullWidth disabled={disabled} aria-label="Name rating">
      {scores.map((score) => (
        <Button
          key={score}
          variant={value === score ? "contained" : "outlined"}
          onClick={() => onChange(value === score ? undefined : score)}
          sx={{ minWidth: 0, px: { xs: 1, sm: 2 }, textTransform: "none" }}
        >
          {ratingLabels[score]}
        </Button>
      ))}
    </ButtonGroup>
  </Stack>
);
